import { Alert, BodyText } from '@utilitywarehouse/hearth-react';

import { FeatureFlags } from '@constants/featureFlags';
import { useFeatureFlag } from '@hooks/useFeatureFlag';

import './styles.scss';

const PriceUpdateAlert = () => {
  const { value: enabled } = useFeatureFlag(
    FeatureFlags.ENERGY_SHOW_SVT_ALERT,
    false
  );

  if (!enabled) {
    return null;
  }

  return (
    <div className="energy_priceUpdateAlert">
      <Alert colorScheme="info">
        <BodyText>
          The Variable and Tracker quotes displayed here reflect the rates that
          come into effect on the 1st October 26, which include VAT at 0% for
          electricity and 5% for Gas. If your supply starts before then, you'll
          be charged the July rates and 5% VAT on both fuels. These July rates
          can be found in the Tariff Information Labels on our website.
        </BodyText>
        <BodyText>
          Fixed quotes include VAT at 0% for electricity and 5% for Gas, however
          will have the higher 5% for electricity applied for any consumption
          prior to the 1st October 26.
        </BodyText>
      </Alert>
    </div>
  );
};

export { PriceUpdateAlert };
